const AuthConstants = {
  userCookieKey: "dcos-acs-info-cookie"
};

module.exports = AuthConstants;



// WEBPACK FOOTER //
// ./src/js/constants/AuthConstants.js